import { render, staticRenderFns } from "./ListWrapper.vue?vue&type=template&id=04d7ca66"
import script from "./ListWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ListWrapper.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports